<template>
  <div
    v-if="useIsMobile()"
    class="scan"
  >
    <i
      class="iconfont-midea iconscan"
      @click="scan"
    />
  </div>
  <div
    v-else
    class="scan"
  >
    <input
      ref="scanInput"
      :value="files"
      type="file"
      accept="image/*;capture=camera"
      @change="handleChange"
    >
    <i class="iconfont-midea iconxiangji" />
  </div>
</template>

<script>
import Quagga from "quagga";
import QrcodeDecoder from "qrcode-decoder";
import { useWarnningMsgBox } from "@/hooks/common/msg-box/useWarnningMsgBox";
import { useIsMobile } from "@/hooks/common/useUtils";

export default {
  props: {
    site: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      state: {
        inputStream: {
          size: 800,
          singleChannel: false,
        },
        locator: {
          patchSize: "medium",
          halfSample: true,
        },
        decoder: {
          readers: [
            {
              format: "code_128_reader",
              config: {},
            },
          ],
        },
        locate: true,
        src: null,
      },
      files: [],
    };
  },
  mounted() {
    this.addScanDom();
  },
  methods: {
    useIsMobile,
    scan() {
      const resultCollector = Quagga.ResultCollector.create({
        capture: true,
        capacity: 20,
        blacklist: [
          {
            code: "WIWV8ETQZ1",
            format: "code_93",
          },
          {
            code: "EH3C-%GU23RK3",
            format: "code_93",
          },
          {
            code: "O308SIHQOXN5SA/PJ",
            format: "code_93",
          },
          {
            code: "DG7Q$TV8JQ/EN",
            format: "code_93",
          },
          {
            code: "VOFD1DB5A.1F6QU",
            format: "code_93",
          },
          {
            code: "4SO64P4X8 U4YUU1T-",
            format: "code_93",
          },
        ],
        filter: function() {
          // only store results which match this constraint
          // e.g.: codeResult
          return true;
        },
      });
      const App = {
        status: null,
        init: function() {
          const self = this;

          Quagga.init(this.state, function(err) {
            if (err) {
              return self.handleError(err);
            }
            document.querySelector('#interactive-container').style.display = 'block';
            App.checkCapabilities();
            Quagga.start();
          });
        },
        handleError: function(err) {
          console.log(err);
          this.status = 'fail';
        },
        checkCapabilities: function() {
          const track = Quagga.CameraAccess.getActiveTrack();
          let capabilities = {};
          if (typeof track.getCapabilities === "function") {
            capabilities = track.getCapabilities();
          }
          this.applySettingsVisibility("zoom", capabilities.zoom);
          this.applySettingsVisibility("torch", capabilities.torch);
        },
        updateOptionsForMediaRange: function(node, range) {
          console.log("updateOptionsForMediaRange", node, range);
          const NUM_STEPS = 6;
          const stepSize = (range.max - range.min) / NUM_STEPS;
          let option;
          let value;
          while (node.firstChild) {
            node.removeChild(node.firstChild);
          }
          for (let i = 0; i <= NUM_STEPS; i++) {
            value = range.min + stepSize * i;
            option = document.createElement("option");
            option.value = value;
            option.innerHTML = value;
            node.appendChild(option);
          }
        },
        applySettingsVisibility: function(setting, capability) {
          // depending on type of capability
          if (typeof capability === "boolean") {
            const node = document.querySelector(
              'input[name="settings_' + setting + '"]'
            );
            if (node) {
              node.parentNode.style.display = capability ? "block" : "none";
            }
            return;
          }
          if (
            window.MediaSettingsRange &&
            capability instanceof window.MediaSettingsRange
          ) {
            const node = document.querySelector(
              'select[name="settings_' + setting + '"]'
            );
            if (node) {
              this.updateOptionsForMediaRange(node, capability);
              node.parentNode.style.display = "block";
            }
            return;
          }
        },
        _printCollectedResults: function() {
          const results = resultCollector.getResults();
          console.log("results", results);
        },
        state: {
          inputStream: {
            type: "LiveStream",
            constraints: {
              width: { min: 1280 },
              height: { min: 720 },
              facingMode: "environment",
              aspectRatio: { min: 1, max: 2 },
            },
          },
          locator: {
            patchSize: "medium",
            halfSample: true,
          },
          numOfWorkers: 8,
          frequency: 10,
          decoder: {
            readers: [
              {
                format: "code_128_reader",
                config: {},
              },
            ],
          },
          locate: true,
        },
        lastResult: null,
      };

      App.init();

      if (App.status === 'fail') {return;}

      Quagga.onProcessed(function(result) {
        const drawingCtx = Quagga.canvas.ctx.overlay,
          drawingCanvas = Quagga.canvas.dom.overlay;

        if (result) {
          if (result.boxes) {
            drawingCtx.clearRect(
              0,
              0,
              parseInt(drawingCanvas.getAttribute("width")),
              parseInt(drawingCanvas.getAttribute("height"))
            );
            result.boxes
              .filter(function(box) {
                return box !== result.box;
              })
              .forEach(function(box) {
                Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
                  color: "#07c160",
                  lineWidth: 2,
                });
              });
          }

          if (result.box) {
            Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
              color: "#0099da",
              lineWidth: 2,
            });
          }

          if (result.codeResult && result.codeResult.code) {
            Quagga.ImageDebug.drawPath(
              result.line,
              { x: "x", y: "y" },
              drawingCtx,
              { color: "#ec1c24", lineWidth: 3 }
            );
          }
        }
      });

      Quagga.onDetected(this.handleDetected);
    },
    handleDetected (result){
      const code = result.codeResult.code;
      console.log("-----------------------");
      console.log("result", result);
      console.log("code", code);

      if (code) {
        this.$emit("scan", code);
        this.stopScan();
      }
    },
    addScanDom () {
      const interactive = document.createElement("div");
      interactive.id = "interactive-container";
      interactive.innerHTML=`
      <div class="viewport-cover"></div>
      <div class="interactive-triangle"></div>
      <div id="interactive" class="viewport"></div>
      `;
      document.body.appendChild(interactive);

      document.querySelector(".viewport-cover").addEventListener('click', () => {
        this.stopScan();
      });
    },
    stopScan () {
      Quagga.stop();
      Quagga.offDetected(this.handleDetected);
      document.querySelector('#interactive-container').style.display = 'none';
    },
    handleChange(e) {
      const { files } = e.target;
      if (files && files.length) {
        this.decode(this.getObjectURL(files[0]));
      }
    },
    getObjectURL(file) {
      return window.URL && window.URL.createObjectURL
        ? window.URL.createObjectURL(file)
        : window.webkitURL.createObjectURL(file);
    },
    async decode(src) {
      const res =
        (await this.decodeForQrCode(src)) ||
        (await this.decodeForBarCode(src));
      if (!res) {useWarnningMsgBox('the SN you type cannot be  recognized');}
      else {this.$emit("scan", res);}
      // TODO: 解析后清空输入框内的文件
      this.$refs.scanInput.value = "";
    },
    decodeForBarCode(src) {
      return new Promise((resolve) => {
        const config = {
          ...this.state,
          src
        };
        Quagga.decodeSingle(config, (result = {}) => {
          const { codeResult = {} } = result || {};
          const { code = false } = codeResult || {};
          resolve(code);
        });
      });
    },
    decodeForQrCode(src) {
      return new Promise((resolve) => {
        const qr = new QrcodeDecoder();

        qr.decodeFromImage(src).then((res) => {
          resolve(res && res.data);
        });
      });
    },

    decodeForZxing(src) {
      return new Promise((resolve) => {
        const img = document.createElement("img");
        img.src = src;
        
        // eslint-disable-next-line
        const codeReader = new ZXing.BrowserBarcodeReader();

        codeReader
          .decodeFromImage(img)
          .then((result = {}) => {
            console.log("decodeForZxing", result);
            if (result.text) {resolve(result.text || false);}
          })
          .catch(() => resolve(false));

        console.log(`Started decode for image from ${img.src}`);
      });
    },
  },
};
</script>